import { defineStore } from "pinia";

import { AxiosClient } from "../axios/axios";
import { ClearToken, GetToken, SaveToken } from "../helpers/encrypt";
import router from "../router";
export const useAuthStore = defineStore("authStore", {
  state: () => ({
    user: null,
    name: null,
    email: null,
    prvi: [],
    isLoading: false,
  }),

  getters: {
    isLoggedIn: () => GetToken() != null,
  },
  actions: {
    //Clear errors Action Start
    async clearErrors() {
      this.error = "";
      this.errors = {};
    },
    //clear errors end start
    //Login Action Start
    async login(formData) {
      this.isLoading = true;

      return new Promise((resolve, reject) => {
        AxiosClient.post(`/signin`, formData, {
          withCredentials: true,
        })
          .then((res) => {
            if (res.status === 201) {
              SaveToken(res.data.userToken);
              this.isLoading = false;
              resolve(res);
            }
          })
          .catch((error) => {
            this.isLoading = false;
            reject(error);
          });
      });
    },
    //Login Action End
    //Logout Action Start
    async logout() {
      try {
        ClearToken();
        this.user = null;
        this.isLoading = false;
        router.push({ name: "login" });
      } catch (error) {
        ClearToken();
        this.user = null;
        this.isLoading = false;
        router.push({ name: "login" });
      }
    },
    //Logout Action End

    // Get User Action Start
    async getUser() {
      return new Promise((resolve, reject) => {
        AxiosClient.get(`usr`)
          .then((res) => {
            if (res.status === 201 || res.status === 200) {
              this.user = res?.data?.info;
              this.name = res?.data?.info?.name;
              this.email = res?.data?.info?.email;
              this.prvi = res?.data?.info?.abilities;
              resolve(res.data);
            }
          })
          .catch((error) => {
            if (error?.status === 401) {
              this.logout();
            }
            reject(error);
          });
      });
    },
    // Get User Action End

    // Get User Action Start
    async updatePassword(payload) {
      return new Promise((resolve, reject) => {
        AxiosClient.post(`usr`, payload)
          .then((res) => {
            if (res.status === 201 || res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((error) => {
            if (error?.status === 401) {
              this.logout();
            }
            reject(error);
          });
      });
    },
    // Get User Action End

    // get privileges

    getPrivileges() {
      return new Promise((resolve, reject) => {
        AxiosClient.get(`v1/permissions`, {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("token") ?? this.token,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // end of get privileges
  },
});
